<template>
<div class="vip-experience">
  <!-- <Button>立即开通</Button> -->
  <img :src="static_img_url+'mobile/pic/vip/logo.png'" class="logo">
  <div class="title">动脉网VIP体验包</div>
  <div class="tip">
    <span>限购一次</span>
  </div>
  <div class="summary">感谢支持，请点击立即开通按钮填写资料，我们将即时为您开通VIP。</div>
  <div class="btn-content" @click="handleClickExp">
    <div class="btn">
      <template v-if="status == '1'">立即开通</template>
      <template v-if="status == '2'">请登录后开通</template>
      <template v-if="status == '3'">已领完</template>
      <template v-if="status == '4'">您已经参与过该活动</template>
      <template v-if="status == '5'">已失效</template>
      <i class="iconfont">&#xe8d4;</i>
    </div>
    <p>请务必准确无误填写信息，这关系到后续的VIP权益</p>
  </div>
  <div class="info">
    <div class="info-title">体验包权益<img :src="static_img_url+'mobile/pic/vip/point_title.png'"></div>
    <p>有效期内享有动脉网官网VIP服务</p>
    <div class="info-list">
      <div><span>快讯live查询解锁，无限量查找搜索</span><img :src="static_img_url+'mobile/pic/vip/icon1.png'" class="icon"><img :src="static_img_url+'mobile/pic/vip/point.png'" class="point"></div>
      <div><span>专题Pro全面解锁，畅享深度事件专题</span><img :src="static_img_url+'mobile/pic/vip/icon2.png'" class="icon"><img :src="static_img_url+'mobile/pic/vip/point.png'" class="point"></div>
      <div><span>数据π搜索解锁，动脉网全量数据供您使用</span><img :src="static_img_url+'mobile/pic/vip/icon3.png'" class="icon"><img :src="static_img_url+'mobile/pic/vip/point.png'" class="point"></div>
      <div><span>研图View彻底开放，洞察医疗投融动态</span><img :src="static_img_url+'mobile/pic/vip/icon4.png'" class="icon"><img :src="static_img_url+'mobile/pic/vip/point.png'" class="point"></div>
      <div><span>工作台Max强力信息定制工具，实现高效信息获取</span><img :src="static_img_url+'mobile/pic/vip/icon5.png'" class="icon"><img :src="static_img_url+'mobile/pic/vip/point.png'" class="point"></div>
    </div>
  </div>
</div>
</template>
<script>
import { checkVipGiveEffectiveness } from '../service'
export default {
  data() {
    return {
      status: '1'
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
    static_img_url() {
      return this.$store.state.static_img_url
    }
  },
  methods: {
    async checkVipGiveEffectiveness() {
      let res = await checkVipGiveEffectiveness({
        p: this.$route.query.p,
        sign: this.$route.query.sign,
        user_key: this.user_key
      })
      if (res.status == 'success') {
        if(res.give_count == '0') {
          this.status = '3'
        } else {
          this.status = this.user_key ? '1' : '2'
        }
      } else {
        if(res.code == '10004') {
          this.status = '4'
        } else if(res.code == '10003'){
          this.status = '5'
        }
        this.$Message.error(res.message)
      }
    },
    handleClickExp() {
      if (this.status == '1' || this.status == '2') {
        if(this.user_key) {
          this.$router.push({name: 'MCollectInfo', query: { p: this.$route.query.p, sign: this.$route.query.sign}})
        } else {
          this.$router.push({name: 'MLogin', query: { url: escape(this.$route.fullPath)}})
        }
      }
    }
  },
  created() {
    this.checkVipGiveEffectiveness()
  }
}
</script>
<style lang="stylus" scoped>
.vip-experience
  background-color: #001a5c
  background-image: url('~mobile/pic/vip/bg.png'), url('~mobile/pic/vip/bg3.png'), url('~mobile/pic/vip/bg2.png')
  background-repeat: no-repeat, no-repeat, no-repeat
  background-size: 100% auto, 1.4rem auto, 100% auto
  background-position: left top, left center, left bottom
  padding: .4rem 0
  .logo
    width: 1.65rem
    height: .51rem
    margin-left: .6rem
  .title
    font-size: .76rem
    font-weight: 800
    color: rgba(255,255,255,1)
    margin: 1.34rem .7rem 0
  .tip
    margin: .5rem .7rem 0
    span
      width: 1.78rem
      height: .46rem
      border: .03rem solid
      border-image: linear-gradient(136deg, rgba(165,161,255,1), rgba(64,97,233,1)) 10 10
      background: linear-gradient(270deg,rgba(30,89,230,0.13) 0%,rgba(95,65,215,1) 100%)
      border-radius: .09rem
      font-size: .28rem
      font-weight: 500
      color: rgba(255,255,255,1)
      line-height: .44rem
      text-align: center
      display: block
  .summary
    font-size: .36rem
    font-weight: 500
    color: rgba(255,255,255,1)
    line-height: 0.52rem
    margin: .5rem .7rem 0
  .btn-content
    z-index: 100
    position: fixed
    width: calc(100% - 1.4rem)
    bottom: .6rem
    left: .7rem
    padding: .24rem 0 .24rem .3rem
    box-shadow: 0 .03rem .07rem 0 rgba(0, 0, 0, 0.35)
    border-radius: .09rem
    border:1px solid rgba(255,255,255,1)
    background:linear-gradient(270deg,rgba(30,89,230,1) 0%,rgba(243,2,50,1) 100%)
    .btn
      font-size: .36rem
      font-weight: 800
      color: rgba(255,255,255,1)
      padding-right: .3rem
      i
        float: right
    p
      font-size: .22rem
      font-weight: 500
      color:rgba(238,238,238,1)
      margin-top: .16rem
  .info
    margin: 1.4rem .7rem 0
    .info-title
      position: relative
      display: table
      font-size: .32rem
      color: #fff
      font-weight: 800
      margin: 0 auto
      z-index: 1
      &:after
        content: ''
        position: absolute
        width: 1.2rem
        height: .3rem
        background-color: #FE3336
        right: -.4rem
        bottom: -.15rem
        z-index: -2
      img
        position: absolute
        width: .52rem
        height: .27rem
        z-index: -1
        right: -.64rem
    > p
      margin-top: .42rem
      font-size: .28rem
      color: #fff
      font-weight: 800
      text-align: center
    .info-list
      margin: .6rem 0
      text-align: center
      padding-bottom: 1.68rem
      > div
        position: relative
        z-index: 1
        display: inline-block
        span
          display: inline-block
          min-width: 5.46rem
          padding: 0 .22rem
          height: .86rem
          line-height: .82rem
          border: .02rem solid
          border-image: linear-gradient(136deg, rgba(165,161,255,1), rgba(64,97,233,1)) 10 10
          background: linear-gradient(270deg,rgba(30,89,230,0.13) 0%,rgba(95,65,215,1) 100%)
          text-align: center
          font-size: .26rem
          font-weight: bold
          color: rgba(255,255,255,1)
          border-radius: .09rem
          white-space:nowrap
        img
          position: absolute
          width: 1.2rem
          height: .62rem
          z-index: -1
          left: -.58rem
          bottom: -.4rem
          &.icon
            width: .8rem
            height: .8rem
            z-index: 2
            left: auto
            right: -.4rem
            bottom: -.4rem
        &+div
          margin-top: 1.29rem
        &:nth-of-type(even)
          span
            border-image:linear-gradient(136deg, rgba(165,161,255,1), rgba(64,97,233,1)) 10 10
            background:linear-gradient(90deg,rgba(30,89,230,0.13) 0%,rgba(95,65,215,1) 100%)
          img
            right: -.58rem
            left: auto
            &.icon
              left: -.62rem
              right: auto
</style>
